<template>
	<div class="nav vue-warning" v-show="visible">
		<Modal
			:visible="visible"
			title="VUE Update"
			:description="description"
			:clickClose="acknowledgeWarning"
			:hasCloseBtn="!isFinalWarning"
			class="vue-warning__modal"
		>
			<template v-slot:body>
				{{ message }}
			</template>
			<template v-slot:footer>
				<button
					class="btn btn-default button-small"
					v-if="isFinalWarning"
					@click="refreshPage"
				>
					Refresh
				</button>
				<button
					class="btn btn-default button-small"
					v-else
					@click="acknowledgeWarning"
				>
					Ok
				</button>
			</template>
		</Modal>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/shells/modal/modal.vue';

export default {
	name: 'VueWarning',
	components: {
		Modal
	},
	data() {
		return {
			dismissed: false,
			message: null,
			description: null,
			interval: null,
			currentDateTime: new Date()
		};
	},
	computed: {
		...mapGetters('user', ['zoneWarning']),
		isFinalWarning() {
			if (!this.zoneWarning) return false;
			const deadline = new Date(this.zoneWarning.Deadline);
			return this.currentDateTime >= deadline;
		},
		visible() {
			return !!(this.zoneWarning && this.message && !this.dismissed);
		}
	},
	methods: {
		...mapActions('user', ['setZoneWarning']),
		acknowledgeWarning() {
			if (this.isFinalWarning) this.refreshPage();

			if (this.zoneWarning && !this.interval) {
				this.interval = setInterval(
					this.updateWarningMessage,
					this.zoneWarning.IntervalMinutes * 60 * 1000
				);
			}
			this.dismissed = true;
		},
		updateWarningMessage() {
			this.dismissed = false;
			if (!this.zoneWarning) return;

			this.currentDateTime = this.getCurrentDateTime();

			const startTime = new Date(this.zoneWarning.StartTime);
			const deadline = new Date(this.zoneWarning.Deadline);

			if (
				this.currentDateTime >= startTime &&
				this.currentDateTime < deadline
			) {
				this.message = this.zoneWarning.InitialMessage;
			} else if (this.currentDateTime >= deadline) {
				this.stopWarningUpdates();
				this.message = this.zoneWarning.FinalMessage;
			}
		},
		stopWarningUpdates() {
			clearInterval(this.interval);
			this.interval = null;
		},
		refreshPage() {
			window.location.reload();
		},
		getCurrentDateTime() {
			return new Date();
		}
	},
	watch: {
		zoneWarning: {
			immediate: true,
			handler() {
				this.updateWarningMessage();
			}
		}
	},
	beforeDestroy() {
		this.stopWarningUpdates();
	}
};
</script>

<style lang="scss" scoped>
.modal {
	&__footer > button {
		padding: $padding-xs $padding-sm;
	}
}
</style>
